import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { BellRing, CalendarClock } from "lucide-react";
import { t } from "@/lib/i18n";

const RemindersCard = () => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/reminders").then(
      (r) => { setItems(r.data); setLoading(false); },
      () => setLoading(false),
    );
  }, []);

  if (loading) return null;
  if (!items.length) return null;

  return (
    <div className="card-flat" data-testid="reminders-card">
      <div className="flex items-center gap-2 mb-3">
        <BellRing size={16} className="text-[#2F524A]" />
        <h3 className="font-serif text-xl">{t("Reminders")}</h3>
      </div>
      <ul className="space-y-3">
        {items.map((r) => (
          <li
            key={r.kind}
            data-testid="reminder-item"
            data-due={r.due}
            className={`p-3 rounded-xl border ${
              r.due ? "border-[#E07A5F] bg-[#FBE6DF]" : "border-[#E8ECEA] bg-[#FAFAFA]"
            }`}
          >
            <div className="flex items-start gap-2">
              <CalendarClock
                size={16}
                className={r.due ? "text-[#7A2E22]" : "text-[#5C6661]"}
              />
              <div>
                <p className="text-sm font-semibold text-[#1C201F]">{t(r.title)}</p>
                <p className="text-xs text-[#5C6661] mt-0.5 leading-relaxed">{t(r.detail)}</p>
              </div>
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default RemindersCard;
